/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Password_ChangedInputs */



/**
* | output |
* | --- |
* | "Password changed" |
*
* @param {Profile_Password_ChangedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_password_changed = /** @type {((inputs?: Profile_Password_ChangedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Password_ChangedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot de passe modifié")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contraseña cambiada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Senha alterada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Password modificata")
	return /** @type {LocalizedString} */ ("Password changed")
});